var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(-2.15 -2.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2697",
    "data-name": "Group 2697",
    transform: "translate(2.15 2.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    d: "M6.324-.85A7.174,7.174,0,1,1-.85,6.324,7.182,7.182,0,0,1,6.324-.85Zm0,12.97a5.8,5.8,0,1,0-5.8-5.8A5.8,5.8,0,0,0,6.324,12.12Z",
    transform: "translate(0.85 0.85)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M19.046,19.735a.687.687,0,0,1-.487-.2L16,16.976A.689.689,0,0,1,16.976,16l2.557,2.557a.689.689,0,0,1-.487,1.176Z",
    transform: "translate(-4.735 -4.735)",
    fill: "#a5a5a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5c9eee58fbe6479ce73406a4462eb0da.svg";
export { ForwardRef as ReactComponent };